<template>
  <div class="flex">
    <div
      v-for="(item, index) in breadcrumb"
      :key="index"
      class="px-0 pt-0 pb-3"
    >
      <a
        v-if="item.to === 'back'"
        :class="index == breadcrumb.length - 1 ? 'font-bold' : ''"
        @click="$router.go(-1)"
        class="font__12 font-weight-medium"
        style="cursor: pointer!important;"
        >{{ item.text }}
      </a>
      <router-link
        v-else
        :class="index == breadcrumb.length - 1 ? 'font-bold' : ''"
        :to="item.to"
        :disabled="item.disabled"
        class="font__12 font-weight-medium"
        >{{ item.text }}
      </router-link>
      <span v-if="index != breadcrumb.length - 1" class="mx-1">
        >
      </span>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  props: ["breadcrumb"],
});
</script>
